module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"labels":{"createTask":"Create task","manageSubscription":"Manage subscription","manageServices":"Manage services","document":{"withdrawApproval":"Withdraw approval","approveDocument":"Approve document"}}}}')
  delete Component.options._Ctor
}
